import { createRouter, createWebHistory } from "vue-router";
import Dashboard from "../views/Dashboard.vue";
import SalesPoints from "../views/SalesPoints.vue";
import Invoicer from "../views/Invoicer.vue";
import Invoicings from "../views/Invoicings.vue";
import User from "../views/User.vue";
import Signin from "../views/Signin.vue";
import ErrorLogs from "../views/ErrorLogs.vue";
import Statistics from "../views/Statistics.vue";
import { decrypt } from '../utils/crypto';

const routes = [
  {
    path: "/",
    name: "Signin",
    component: Signin,
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    meta: { requireAuth: true, roles: [1, 2] }
  },
  {
    path: "/sales-points",
    name: "SalesPoints",
    component: SalesPoints,
    meta: { requireAuth: true, roles: [1] }
  },
  {
    path: "/invoicer",
    name: "Invoicer",
    component: Invoicer,
    meta: { requireAuth: true, roles: [1] }
  },
  {
    path: "/invoicings",
    name: "Invoicings",
    component: Invoicings,
    meta: { requireAuth: true, roles: [1, 3] }
  },
  {
    path: "/users",
    name: "User",
    component: User,
    meta: { requireAuth: true, roles: [1] }
  },
  {
    path: "/error-logs",
    name: "ErrorLogs",
    component: ErrorLogs,
    meta: { requireAuth: true, roles: [1] }
  },
  {
    path: "/statistics",
    name: "Statistics",
    component: Statistics,
    meta: { requireAuth: true, roles: [1] }
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

router.beforeEach((to, from, next) => {
  const authRequired = to.matched.some(record => record.meta.requireAuth);
  const validateLogin = localStorage.getItem('token');
  const profile = localStorage.getItem('setProfile');
  const deProfile = !profile ? 0 : JSON.parse(decrypt(profile)); // Perfil numérico del usuario

  if (authRequired && !validateLogin) {
    next({ name: 'Signin' });
  } else if (authRequired && validateLogin) {
    const rolesAllowed = to.meta.roles;
    if (rolesAllowed && rolesAllowed.includes(deProfile)) {
      next(); // Si el perfil del usuario está en la lista de roles permitidos
    } else {
      next({ name: 'Signin' }); // Redirige a página de error de acceso denegado
    }
  } else {
    next(); // Si no requiere autenticación, continúa
  }
});

export default router;
